import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/auth/auth-context';
import { I18nProvider } from '@/i18n/i18n-provider';
import { AppRouter } from '@/app/router';
import { queryClient } from '@/app/query-client';
import '@/styles/global.css';
import '@/components/ui.css';
import '@/styles/layout.css';
import '@/styles/people.css';
import '@/styles/calendar.css';
import '@/styles/print.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    {/*
      I18nProvider is outermost: it sets `lang` and `dir` on the document, and
      every component below reads its translations.
    */}
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
